var map = {
	"./ApplyIdo/ApplyIdo": 17580,
	"./ApplyIdo/ApplyIdo.js": 17580,
	"./Calendar/Calendars": 20678,
	"./Calendar/Calendars.js": 20678,
	"./Claim/Claim": 35165,
	"./Claim/Claim.js": 35165,
	"./Common/Footer": 26071,
	"./Common/Footer.js": 26071,
	"./Common/Header": 77260,
	"./Common/Header.js": 77260,
	"./ContactUs/ContactUs": 70335,
	"./ContactUs/ContactUs.js": 70335,
	"./Features/Features": 2322,
	"./Features/Features.js": 2322,
	"./HomePage/Home": 53825,
	"./HomePage/Home.js": 53825,
	"./LaunchPad/Launchpad": 56533,
	"./LaunchPad/Launchpad.js": 56533,
	"./LaunchPad/LaunchpadItem": 18236,
	"./LaunchPad/LaunchpadItem.js": 18236,
	"./LaunchPad/ProjectDetails": 19465,
	"./LaunchPad/ProjectDetails.js": 19465,
	"./LaunchPad/TabComponent": 62216,
	"./LaunchPad/TabComponent.js": 62216,
	"./Mycalender": 61397,
	"./Mycalender.js": 61397,
	"./Profile/Profile": 97847,
	"./Profile/Profile.js": 97847,
	"./Profile/partials/StakingPoolDetailsModal": 23788,
	"./Profile/partials/StakingPoolDetailsModal.js": 23788,
	"./SocketTest": 70793,
	"./SocketTest.js": 70793,
	"./Staking-Farming/StakingFarming": 83232,
	"./Staking-Farming/StakingFarming.js": 83232,
	"./Staking-Farming/partials/CalculatorModal": 32851,
	"./Staking-Farming/partials/CalculatorModal.js": 32851,
	"./Staking-Farming/partials/StakingInfoBox": 76287,
	"./Staking-Farming/partials/StakingInfoBox.js": 76287,
	"./Staking-Farming/partials/TabContent": 27268,
	"./Staking-Farming/partials/TabContent.js": 27268,
	"./Staking-Farming/partials/Tier": 75746,
	"./Staking-Farming/partials/Tier.js": 75746,
	"./TierSystem/TierSystem": 82856,
	"./TierSystem/TierSystem.js": 82856,
	"./constant": 76466,
	"./constant/": 76466,
	"./constant/index": 76466,
	"./constant/index.js": 76466,
	"./customCalender.css": 37033,
	"./img/bnb.png": 9021,
	"./img/bnb_black.png": 98279,
	"./img/chain.png": 29840,
	"./img/discord.webp": 14440,
	"./img/ethereum.png": 49024,
	"./img/ethereum_icon.png": 13566,
	"./img/logo.jpg": 65209,
	"./img/logo.webp": 85508,
	"./img/polygon_icon.png": 3913,
	"./img/previous-image.png": 93772,
	"./img/previous-image2.png": 60676,
	"./img/previous-image3.png": 15558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78416;